import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { dispatcher, RootState } from "../utils/store";

export const useAppDispatcher = () => useDispatch<dispatcher>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;